import type { Transition } from 'motion/react';

type TTransitions = {
  entrance: Transition;
  soft: Transition;
  snappy: Transition;
  fade: Transition;
  staggerDelay: number;
};

export const transitions: TTransitions = {
  entrance: { type: 'spring', stiffness: 300, damping: 30 },
  soft: { type: 'spring', stiffness: 200, damping: 28 },
  snappy: { type: 'spring', stiffness: 400, damping: 40 },
  fade: { type: 'tween', duration: 0.25, ease: [0.22, 1, 0.36, 1] },
  staggerDelay: 0.06,
};
